import { forwardRef } from 'react';
import styled from 'styled-components';
import { UnicodeEntity } from '@mews/enums';
import { FilterChip, Icon, IconName, Stack, Typography } from '@optimus-web/core';

interface FilterInputTriggerProps {
    dataTestId: string;
    leftIcon?: IconName;
    onClick: () => void;
    prefix?: string;
    showDropdownIcon?: boolean;
    suffix?: React.ReactNode;
    value: string;
}

export const FilterInputTrigger = forwardRef<HTMLButtonElement, FilterInputTriggerProps>(
    ({ dataTestId, leftIcon, onClick, prefix, showDropdownIcon = true, suffix, value }, ref) => (
        <Wrapper
            data-test-id={dataTestId}
            icon={showDropdownIcon ? IconName.ChevronDown : undefined}
            onClick={onClick}
            ref={ref}
            size="small"
        >
            <Stack spacing="50" itemAlignment="center">
                {leftIcon ? <Icon size="small" value={leftIcon} /> : null}
                {prefix ? (
                    <Prefix textStyle="bodyMedium" variant="tertiary" as="div">
                        {prefix}
                        {UnicodeEntity.Colon}
                    </Prefix>
                ) : null}
                <Typography ellipsis textStyle="bodyMedium" data-test-element={`${dataTestId}-value`} as="div">
                    {value}
                </Typography>
                {suffix}
            </Stack>
        </Wrapper>
    )
);

const Wrapper = styled(FilterChip)`
    max-width: 100%;
    min-width: 0;
`;

const Prefix = styled(Typography)`
    flex: 0 0 auto;
`;
